import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ImportField } from '../csv-importer.component';
import { ParseResult } from 'ngx-papaparse';
import { Strings } from 'src/app/text/strings';

@Component({
  selector: 'app-csv-matcher',
  templateUrl: './matcher.component.html',
  styleUrls: ['./matcher.component.scss']
})
export class MatcherComponent implements OnInit {

  @Input() fields?: ImportField<any>[];
  @Input() parseResult?: ParseResult;
  @Output() onMatchChange = new EventEmitter<ImportField<any>>();
  @Output() onMatchComplete = new EventEmitter();

  _page = -1;
  currentPage?: any[];
  pageSize = 20;

  constructor() { }

  ngOnInit() {
    this.page = 0;
  }

  get totalPages() {
    return Math.ceil(this.parseResult?.data?.length / this.pageSize);
  }

  get page() {
    return this._page;
  }
  
  set page(value: number) {
    this._page = value;
    const start = this.page * this.pageSize;
    const end = start + this.pageSize;
    this.currentPage = this.parseResult?.data?.slice(start, end);
  }

  get fieldsAbs(): string[] {
    const result: string[] = [];
    this.parseResult?.meta.fields.forEach(f => {
      if(f != null && f.trim() != '') {
        result.push(f);
      }
    })
    return result;
  }

  hasInvalidFields() {
    return this.fields?.map(f => !f.valid).reduce((prev, curr) => {
      return prev === true ? true : curr;
    });
  }

  isValid(field: ImportField < any >, index: number) {
    const row = this.page * this.pageSize + index;
    if(field.rows) {
      return field.rows[row].valid;
    } else {
      return true;
    }
  }

  getDataForField(field: ImportField<any>) {
    let data = [];

    for (let i = 0; i < this.parseResult?.data.length && data.length < 3; i++) {
      let entry = this.parseResult?.data[i];
      let value = entry[field?.matchField!];
      if (value != null && value != '') {
        data.push(value);
      }
    }
    return data;
  }

  approve() {
    this.onMatchComplete.emit();
  }

  onStatusChange() {
    let hasIncomplete = false;
    this.fields?.forEach(f => {
      if(!f.ignored && !f.approved) {
        hasIncomplete = true;
      }
    })

    if(!hasIncomplete) {
      this.onMatchComplete.emit(); 
    }
  }

  fireChange(field: ImportField<any>) {
    this.onMatchChange.emit(field);
  }
}
